import React, { useState, useEffect } from "react";
import { Button, Form, Popup } from "semantic-ui-react";
import { sendSubscription } from "./services/apiSusbscription";

const Suscription = () => {
  const [email, setEmail] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => (email.length > 0 ? setDisabled(false) : setDisabled(true)), [
    email,
  ]);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError("");
      setSuccess(true);
      sendSubscription(email)
        .then((response) => {
          if (response.ok) {
            setMessage("Gracias por suscribirse");
          } else {
            setMessage("Se ha producido un error, inténtelo más tarde.");
          }
        })
        .catch(function (error) {
          setMessage("Se ha producido un error, inténtelo más tarde.");
        });
    } catch (error) {
      setError(error.message);
    } finally {
      setEmail("");
      setLoading(false);
    }
  };
  return (
    <div className="col-md-6 col-lg-3 mx-auto my-md-4 my-0 mt-4 mb-1">
      <>
        <h5 className="text-uppercase mb-4">Suscripción</h5>
        <p>Suscríbete para informarte sobre nuestras promociones y eventos.</p>
        <div>
          <Form
            loading={loading}
            error={Boolean(error)}
            onSubmit={handleSubmit}
            success={success}
          >
            <Form.Input
              name="email"
              onChange={handleChange}
              value={email}
              type="email"
              placeholder="Correo"
              label="Ingrese su correo"
              required
            />

            <Popup
              content={message ? message : "..."}
              on="click"
              pinned
              trigger={
                <Button type="submit" color="black" disabled={disabled}>
                  Suscribirse
                </Button>
              }
            />
          </Form>
        </div>
      </>
    </div>
  );
};

export default Suscription;
